import React from 'react'
import styled from 'styled-components'
import {ELEMENTS_IDS} from 'const'
import Logo from 'components/Logo'

const LogosContainer = styled.div`
  display: flex;
  align-items: center;
`

const HeaderLogo = props => {
  const className = [props.className, ELEMENTS_IDS.brandLogo].filter(Boolean).join(' ')
  return <Logo {...props} className={className} />
}

export {LogosContainer, HeaderLogo}
